import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { applicationChangesDetailsLoader } from './applicationChangesDetailsLoader'

export const ChangesDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$applicationId/warnings-details',
    component: lazyRouteComponent(() => import('./ApplicationChangesDetails')),
    loader: applicationChangesDetailsLoader,
    gcTime: 0
  })
